<template>
  <div v-if="resources.length > 0">
    <v-row class="ma-0">
      <div class="heading">Explore Resources by {{ details.name }}</div>
      <v-spacer />
      <v-btn
        text
        color="indigo accent-3"
        style="text-transform: none;"
        @click="clicked"
      >
        <span>View More</span>
      </v-btn>
    </v-row>
    <v-divider />
    <v-row class="ma-0">
      <v-col v-for="(item, i) in resources" :key="i" cols="12" md="3" sm="4">
        <ResourceCard :resource="item" />
      </v-col>
    </v-row>
  </div>
  <div v-else-if="loading">
    <v-row class="ma-0">
      <div class="heading">Explore Resources by {{ details.name }}</div>
      <v-spacer />
      <v-btn
        text
        color="indigo accent-3"
        style="text-transform: none;"
        @click="clicked"
      >
        <span>View More</span>
      </v-btn>
    </v-row>
    <v-divider />
    <v-row class="ma-0">
      <v-col>
        <v-skeleton-loader
          class="mx-auto"
          max-width="300"
          type="card"
        ></v-skeleton-loader>
      </v-col>
      <v-col>
        <v-skeleton-loader
          class="mx-auto"
          max-width="300"
          type="card"
        ></v-skeleton-loader>
      </v-col>
      <v-col>
        <v-skeleton-loader
          class="mx-auto"
          max-width="300"
          type="card"
        ></v-skeleton-loader>
      </v-col>
      <v-col>
        <v-skeleton-loader
          class="mx-auto"
          max-width="300"
          type="card"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Keys from "../../../constants/keys";
import Axios from "../../../api/BaseAxios";
import { API_CLIENT_URL, ROUTER_URL } from "../../../constants/urls";

import ResourceCard from "../../../components/Resources/ResourceCard";

export default {
  name: "ResourceSample",
  props: ["type", "details"],
  components: {
    ResourceCard,
  },
  data() {
    return {
      resources: [],
      loading: true,
    };
  },
  created() {
    this.getResources();
  },
  computed: {},
  watch: {},
  methods: {
    clicked() {
      switch (this.type) {
        case "Skills":
          this.$store.state.resourceFilters.filterResourceSkill = [
            this.details.id,
          ];
          break;
        case "Language":
          this.$store.state.resourceFilters.filterResourceLanguage = [
            this.details.id,
          ];
          break;
        case "Age Group":
          this.$store.state.resourceFilters.filterResourceAgeGroup = [
            this.details.id,
          ];
          break;
        case "Resource Type":
          this.$store.state.resourceFilters.filterResourceType = [
            this.details.id,
          ];
          break;
        case "Tags":
          this.$store.state.resourceFilters.filterResourceTag = [
            this.details.id,
          ];
          break;
        default:
          break;
      }

      this.$router.push({
        name: ROUTER_URL.publicResource.children.listResources.name,
      });
    },
    getResources() {
      let dataTableParams = {};
      const self = this;
      this.loading = true;

      dataTableParams[Keys.SKILLS] = [];
      dataTableParams[Keys.TAGS] = [];
      dataTableParams[Keys.RESOURCE_TYPES] = [];
      dataTableParams[Keys.COUNTRIES] = [];
      dataTableParams[Keys.LANGUAGES] = [];
      dataTableParams[Keys.AGE_GROUPS] = [];
      dataTableParams[Keys.STATUS] = null;
      dataTableParams[Keys.CLIENTS] = [];
      dataTableParams[Keys.CREATORS] = [];

      switch (this.type) {
        case "Skills":
          dataTableParams[Keys.SKILLS] = [this.details.id];
          break;
        case "Language":
          dataTableParams[Keys.LANGUAGES] = [this.details.id];
          break;
        case "Age Group":
          dataTableParams[Keys.AGE_GROUPS] = [this.details.id];
          break;
        case "Resource Type":
          dataTableParams[Keys.RESOURCE_TYPES] = [this.details.id];
          break;
        case "Tags":
          dataTableParams[Keys.TAGS] = [this.details.id];
          break;
        default:
          break;
      }

      const successHandler = (res) => {
        self.loading = false;
        console.log(res);
        self.resources = res.data.data;
      };

      const failureHandler = (res) => {
        console.log(res);
        self.loading = false;
      };

      // let dataTableParams = {};
      dataTableParams[Keys.LENGTH] = 4;

      dataTableParams[Keys.PAGE] = 1;
      dataTableParams[Keys.SEARCH] = "";

      Axios.request_POST(
        API_CLIENT_URL.publicResourceList,
        dataTableParams,
        {},
        successHandler,
        failureHandler,
        false,
        false
      );
    },
  },
  mounted() {},
};
</script>

<style scoped>
.heading {
  font-weight: 800;
  font-size: 20px;
  line-height: 27px;
  color: #5c658b;
}
</style>
